/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkBusiness} from '../api'

export const useMutationUnlinkBusiness = createReactQueryMutationHook('unlinkBusiness', unlinkBusiness)
